import React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType } from '@fluentui/react';
import IvicosStrings from 'kits/language/stringKit';

interface IColiboDeactivationModalProps {
    isOpen: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

// Same markup as OpenProjectDeactivationModal.
export const ColiboDeactivationModal: React.FC<IColiboDeactivationModalProps> = ({ isOpen, onCancel, onConfirm }) => {
    return (
        <Dialog
            hidden={!isOpen}
            onDismiss={onCancel}
            dialogContentProps={{
                type: DialogType.normal,
                title: IvicosStrings.disableProviderDialogTitle.replace('{0}', IvicosStrings.coliboSettingsToggleLabel),
                subText: IvicosStrings.disableProviderDialogWarning.replace('{0}', IvicosStrings.coliboSettingsToggleLabel)
            }}
            modalProps={{ isBlocking: true, styles: { main: { maxWidth: '90vw', minWidth: 'min(320px, 90vw)' } } }}
        >
            <DialogFooter>
                <DefaultButton text={IvicosStrings.disableProviderDialogCancel} onClick={onCancel} />
                <DefaultButton
                    text={IvicosStrings.disableProviderDialogConfirm}
                    onClick={onConfirm}
                    data-test-id="colibo-deactivation-confirm"
                    styles={{
                        root: { backgroundColor: 'red', borderColor: 'red', color: 'white' },
                        rootHovered: { backgroundColor: '#cc0000', borderColor: '#cc0000', color: 'white' }
                    }}
                />
            </DialogFooter>
        </Dialog>
    );
};
